import type { ChatSummary, UserDto } from '../api/types';

export function canManageSupportNotifications(
  chat: Pick<ChatSummary, 'isSupport'> | null | undefined,
  role: UserDto['role'] | null | undefined,
): boolean {
  return chat?.isSupport === true && (role === 'admin' || role === 'support');
}
